import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const ProgressText = styled.text`
  display: flex;
  align-items: center;
  text-align: center;
`

export const ScoreText = styled.tspan`
  ${Typography.Caption};
  ${FontWeights.DemiBold};
  text-align: center;
  color: ${Colors.Blue90};
`

export const Circle = styled.circle<{ score: number; circleCir: number }>`
  fill: 'none';
  stroke-linecap: 'round';
  transition: stroke-dasharray 0.8s ease-in;
  stroke-dasharray: ${props => (props.score / 100) * props.circleCir} ${props => props.circleCir};
`

export const CompactWrapper = styled.div`
  width: 32px;
`
